import { render, staticRenderFns } from "./EstadoBrasil.vue?vue&type=template&id=3402c29a&lang=pug"
import script from "./EstadoBrasil.vue?vue&type=script&lang=js"
export * from "./EstadoBrasil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports